@if (showButton) {
<button aria-label="Menu button"
        aria-pressed="false"
        class="btn btn-link sidebarCollapse menu-button"
        id="menuButton"
        tabindex="0"
        type="button"
        [disabled]="!showButton"
        (click)="handleToggle($event)"
        (keydown)="handleToggleKey($event)">
  <i class="bi bi-list"></i>
</button>
}
